export default {
  NOT_CHOSEN_YET: "not_chosen_yet",
  SENDER: "sender",
  SENDER_CONNECTED: "sender_connected",
  RECEIVER: "receiver",
  RECEIVER_CONNECTED: "receiver_connected",
  UNAVAILABLE: "unavailable"
};
